function ImpressumPage() {
    return (
        <>
            {/* Einleitung */}
            <div className="intro">
                <p>
                    Impressum und Kontakt bezüglich Webseite:
                </p>
            </div>

            {/* Hauptinhalt */}
            <main>
                <div>
                    <h1>Impressum</h1>

                    <p>
                        <strong>Betreiber:</strong>
                        <br />
                        Ivan Jörg
                        <br />
                        Grossfeldstrasse 2
                        <br />
                        8887 Mels SG
                        <br /><br />

                        <strong>Kontakt:</strong>
                        <br />
                        Mail: irj@bluewin.ch
                    </p>
                </div>
            </main>
        </>
    );
}

export default ImpressumPage;